<template>
  <v-dialog eager v-model="dialog" persistent max-width="350">
    <div class="chooser">
      <v-card>
        <v-card-title class="cyan darken-1 headline">
          <span class="white--text">Chi inizia?</span>
          <v-spacer></v-spacer>
          <v-btn depressed class="white--text" light icon @click="dismiss">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        
        <si-sta-facendo-asta-per></si-sta-facendo-asta-per>
        <v-list v-if="asta_choosers && _.size(asta_choosers) > 0">
          <v-list-item
            v-for="squadraChooser in asta_choosers"
            :key="squadraChooser.id"
            :disabled="squadraChooser.canBeChooser == false"
            v-show="squadraChooser.canBeChooser == true || showAll"
            @click="
              squadraChooser.canBeChooser == true
                ? select(squadraChooser.id)
                : null
            "
          >
            <v-list-item-avatar>
              <img :src="squadra(squadraChooser.id).pic" />
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>{{ squadraChooser.name }}</v-list-item-title>
            </v-list-item-content>

            <v-list-item-action>
              <v-badge
                inline
                color="cyan"
                class="ma-1"
                content="Ultimo chiamante"
                v-if="asta_round.chooser == squadraChooser.id"
              ></v-badge>
              <v-badge
                inline
                color="grey"
                class="ma-1"
                :content="squadraChooser.msgIfNotChooser"
                v-if="squadraChooser.canBeChooser == false"
              ></v-badge>
            </v-list-item-action>
          </v-list-item>
        </v-list>

        <div
          class="lista-vuota"
          v-if="
            asta_choosers && _.size(asta_choosers) == nSquadreNonSelezionabili
          "
        >
          <span>Nessuno ha il diritto di chiamare </span>
          <span
            v-if="ruolo_da_chiamare != Constants.RUOLO_DA_CHIAMARE.QUALUNQUE"
          >
            {{ Constants.RUOLI_NEW[ruolo_da_chiamare].plurale }}</span
          >
        </div>

        <div class="pa-4 text-center" v-if="nSquadreNonSelezionabili > 0">
          <v-btn
            outlined
            depressed
            small
            rounded
            class="cyan--text"
            @click="showAll = !showAll"
          >
            <span v-if="!showAll">Mostra tutti</span>
            <span v-else>Solo selezionabili</span>
          </v-btn>
        </div>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import db from "../../js/db";
import Constants from "../../js/constants";

import mixins from "../../js/mixins";
import toast from "../../js/toast";
import SiStaFacendoAstaPer from "../common/SiStaFacendoAstaPer";
import Vuex from "vuex";

export default {
  name: "asta-chooser",
  mixins: [mixins, toast],
  components: {SiStaFacendoAstaPer},
  data() {
    return {
      dialog: false,
      showAll: false,
    };
  },
  props: {
    selected: {
      type: Function,
      default: function () {},
    },
  },
  mounted() {
    console.log("--> AstaChooser ready.");
    db.on("showChooser", this.show);
  },
  destroyed() {
    console.log("<-- AstaChooser destroyed.");
    db.off("showChooser", this.show);
  },
  methods: {
    show() {
      this.showAll = false;
      this.dialog = true;
    },
    dismiss() {
      this.dialog = false;
    },
    select(id) {
      this.dismiss();
      this.selected(id);
    },
    squadra(id) {
      return this.asta_squadre[id];
    },
  },
  computed: {
    ruolo_da_chiamare() {
      return this.asta_settings.ruolo_da_chiamare;
    },
    nSquadreNonSelezionabili() {
      let counter = 0;
      for (const squadraChooser of Object.values(this.asta_choosers)) {
        if (!squadraChooser.canBeChooser) {
          counter++;
        }
      }
      return counter;
    },
    ...Vuex.mapGetters(["asta_choosers"]),
  },
};
</script>
<style scoped>
.lista-vuota {
  width: 100%;
  text-align: center;
}
</style>
